import classNames from "classnames";
import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import styles from "../../styles/outcomesScale.module.scss";

const Scale = ({
  value,
  className,
  markerPosition,
  markerText,
  markerSubText
}) => (
  <div className={classNames(styles.scaleContainer, styles[markerPosition])}>
    <div className={styles.marker} style={{ left: `calc(${value}%)` }}>
      <div className={styles.markerText}>{markerText}</div>
      {markerSubText && (
        <div className={styles.markerSubText}>{markerSubText}</div>
      )}
    </div>
    <div className={className}>
      <div style={{ width: `${value}%` }} />
    </div>
  </div>
);

Scale.propTypes = {
  className: PropTypes.string,
  markerText: PropTypes.node,
  markerSubText: PropTypes.node,
  markerPosition: PropTypes.oneOf(["top", "bottom"]).isRequired,
  value: PropTypes.oneOf(_.range(0, 101))
};

Scale.defaultProps = {
  className: "",
  markerText: null,
  markerSubText: null,
  value: 0
};

export default Scale;
